module.exports = __webpack_public_path__ + "static/media/show-what-you-know.e5bd365a.gif";


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/show-what-you-know.gif
// module id = 157
// module chunks = 0